import React from 'react'
import ApplicationApprovals from './ApplicationApprovals'
import ApplicationListPage from './ApplicationListPage'

const applicationRoutes = [
  {
    breadcrumb: 'Applications',
    path: '',
    element: <ApplicationListPage />,
    children: [],
  },
  {
    breadcrumb: 'Application Approvals',
    path: 'approvals',
    element: <ApplicationApprovals />,
    children: [],
  },
]

export default applicationRoutes
